function createBangleJSUiCode(x, y, z, renderBox, name, width, height, color) {
  return {
    active: true,
    name,
    x,
    y,
    z,
    renderBoxTlX: renderBox.tl.x,
    renderBoxTlY: renderBox.tl.y,
    renderBoxBrX: renderBox.br.x,
    renderBoxBrY: renderBox.br.y,
    width,
    height,
    color,
    render: function () {
      if (!this.active) return;
      g.setColor(this.color);
      g.fillRect(this.x, this.y, this.x + this.width, this.y + this.height);
    },
  }
}

module.exports = {
  createBangleJSUiCode,
}
